
// import React, { useState, useEffect } from "react";
// import {
//     Box,
//     IconButton,
//     List,
//     ListItem,
//     ListItemButton,
//     ListItemText,
//     Drawer,
//     useMediaQuery,
//     useTheme,
//     Collapse,
// } from "@mui/material";
// import { useNavigate, useLocation } from "react-router-dom";
// import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
// import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
// import {
//     Home as HomeIcon,
//     RestaurantMenu as RestaurantMenuIcon,
//     Apartment as ApartmentIcon,
//     Settings as SettingsIcon,
//     Dashboard as DashboardIcon,
//     DinnerDining as DinnerDiningIcon,
//     Payment as PaymentIcon,
//     Assessment as AssessmentIcon
// } from "@mui/icons-material";
// import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
// import LocalShippingIcon from "@mui/icons-material/LocalShipping";
// import ExpandLess from "@mui/icons-material/ExpandLess";
// import ExpandMore from "@mui/icons-material/ExpandMore";
// import {
//     FaUtensils,
//     FaConciergeBell,
//     FaShoppingBasket,
//     FaBuilding
// } from "react-icons/fa";

// // All possible menu items - these will only open dropdowns, not navigate
// const allMenuItems = [
//     // { text: "Subscription", icon: <HomeIcon />, vertical: "SUBSCRIPTION" },
//     { text: "Food & Beverages", route: "/foodladingpage", vertical: "FOOD_AND_BEVERAGES" },
//     // { text: "Catering & Services", icon: <RestaurantMenuIcon />, vertical: "CATERINGS_SERVICES" },
//     // { text: "Logistics & Supply", icon: <LocalShippingIcon />, vertical: "LOGISTICS_SUPPLY" },
//     // { text: "Fresh & Grocery", icon: <ShoppingBasketIcon />, vertical: "FRESH_GROCERIES" }
// ];

// const subscriptionEnumToMenuItemMap = {
//     Food_Beverages: {
//         text: "Food & Beverages",
//         icon: FaUtensils,
//         route: "/mainladdingpage?vertical=food"
//     },
//     Catering_Services: {
//         text: "Catering & Services",
//         icon: FaConciergeBell,
//         route: "/mainladdingpage?vertical=catering"
//     },
//     Fresh_Grocery: {
//         text: "Fresh & Grocery",
//         icon: FaShoppingBasket,
//         route: "/mainladdingpage?vertical=grocery"
//     },
//     Logistics_Supply: {
//         text: "Logistics & Supply",
//         icon: LocalShippingIcon,
//         route: "/mainladdingpage?vertical=logistics"
//     },
//     Banquet_Hall: {
//         text: "Banquet Hall",
//         icon: FaBuilding,
//         route: "/mainladdingpage?vertical=banquet"
//     },
// };

// // Your actual dropdown content mapping with safe icon handling
// const enumToMenuItemMap = {
//     Home: { text: "Home", icon: HomeIcon, route: "/foodladingpage" },
//     Company: { text: "Profile", icon: ApartmentIcon, route: "/foodbeveragescompany" },
//     Settings_Controls: {
//         text: "Settings & Control",
//         icon: SettingsIcon,
//         route: "/foodsettings"
//     },
//     Menu_Management: {
//         text: "Menu",
//         icon: RestaurantMenuIcon,
//         route: "/foodandbeveragesMenu"
//     },
//     Order_Management: {
//         text: "Order",
//         icon: DashboardIcon,
//         route: "/foodordermanagment"
//     },
//     Chef_Management: {
//         text: "Chef",
//         icon: RestaurantMenuIcon,
//         route: "/foodchefmanagment"
//     },
//     Delivery_Management: {
//         text: "Waiter",
//         icon: DinnerDiningIcon,
//         route: "/foodwaitermanagment"
//     },
//     Account_History: {
//         text: "Account & History",
//         icon: PaymentIcon,
//         route: "/foodAccuontdata"
//     },
//     Promotions_Discounts: {
//         text: "Promotions",
//         icon: PaymentIcon,
//         route: "/foodandbeveragespromotions"
//     },
//     Table_Management: {
//         text: "Table",
//         icon: AssessmentIcon,
//         route: "/foodtablemanagment"
//     },
//     Inventory_Management: {
//         text: "Inventory",
//         icon: PaymentIcon,
//         route: "/foodandbeveragesInvetory"
//     },
//     Report_Analysis: {
//         text: "Report & Analysis",
//         icon: AssessmentIcon,
//         route: "/foodandreporanalysis"
//     },
// };

// const cateringEnumToMenuItemMap = {
//     Home: { text: "Home", icon: HomeIcon, route: "/cateringlading" },
//     Company: { text: "Profile", icon: ApartmentIcon, route: "/cateringsprofilepage" },
//     Settings_Controls: {
//         text: "Settings & Control",
//         icon: SettingsIcon,
//         route: "/cateringssettingpage"
//     },
//     Menu_Management: {
//         text: "Menu",
//         icon: RestaurantMenuIcon,
//         route: "/cateringsmenuaddingpage"
//     },
//     Order_Management: {
//         text: "Leads Orders",
//         icon: DashboardIcon,
//         route: "/cateringsorderspage"
//     },
//     Table_Management: {
//         text: "Package Orders",
//         icon: DashboardIcon,
//         route: "/cateringpackageorders"
//     },
//     Account_History: {
//         text: "Account & History",
//         icon: PaymentIcon,
//         route: "/caterigsaccount"
//     },
//     Promotions_Discounts: {
//         text: "Promotions",
//         icon: PaymentIcon,
//         route: "/cateringspromotionspage"
//     },
//     Report_Analysis: {
//         text: "Report & Analysis",
//         icon: AssessmentIcon,
//         route: "/cateringsreportanalysis"
//     },
// }

// const groceryEnumMenuToMap = {
//     Home: { text: "Home", icon: HomeIcon, route: "/groceryladingpage" },
//     Company: { text: "Profile", icon: ApartmentIcon, route: "/groceryprofiledata" },
//     Settings_Controls: {
//         text: "Settings & Control",
//         icon: SettingsIcon,
//         route: "/grocerysettingsdata"
//     },
//     Menu_Management: {
//         text: "Menu",
//         icon: RestaurantMenuIcon,
//         route: "/groceryandbeveragesMenu"
//     },
//     Order_Management: {
//         text: "Order",
//         icon: DashboardIcon,
//         route: "/groceryorders"
//     },
//     Account_History: {
//         text: "Account & History",
//         icon: PaymentIcon,
//         route: "/groceryaccuontdata"
//     },
//     Promotions_Discounts: {
//         text: "Promotions",
//         icon: PaymentIcon,
//         route: "/groceryandbeveragespromotions"
//     },
//     Inventory_Management: { text: "Inventory", icon: PaymentIcon, route: "/groceryandbeveragesInvetory" },
//     Report_Analysis: {
//         text: "Report & Analysis",
//         icon: AssessmentIcon,
//         route: "/groceryandreporanalysis"
//     },
// }

// const LandingSideBar2 = () => {
//     const [open, setOpen] = useState(false);
//     const [menuItems, setMenuItems] = useState([]);
//     const [dropdownOpen, setDropdownOpen] = useState(false);
//     const [selectedItem, setSelectedItem] = useState(null);
//     const [allowedModules, setAllowedModules] = useState([]);
//     const [allowedBusinessVerticals, setAllowedBusinessVerticals] = useState([]);
//     const navigate = useNavigate();
//     const location = useLocation();
//     const theme = useTheme();

//     // Media queries
//     const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//     const isTablet = useMediaQuery(theme.breakpoints.between("sm", "lg"));
//     const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));
//     const isBelow1315 = useMediaQuery("(max-width:1315px)");
//     const isBetween1315And1399 = useMediaQuery("(min-width:1315px) and (max-width:1399px)");
//     const isAbove1400 = useMediaQuery("(min-width:1450px)");

//     // Your custom window width detection
//     const isMobilee = window.innerWidth < 600;        // < 600px
//     const isTablett = window.innerWidth >= 600 && window.innerWidth < 999; // 600px - 999px
//     const isDesktopp = window.innerWidth >= 999;          // > 999px

//     const showHamburger = isMobilee || isTablett; // true for mobile AND tablet

//     let drawerWidth = 189; // default

//     if (isBelow1315) {
//         drawerWidth = 176;
//     } else if (isBetween1315And1399) {
//         drawerWidth = 190;
//     } else if (isAbove1400) {
//         drawerWidth = 208;
//     }

//     const getIconSize = () => (isMobile ? "small" : "medium");
//     const getTextSize = () => (isMobile ? "11px" : isTablet ? "12px" : "13px");

//     // Set initial open state based on your custom window width detection
//     useEffect(() => {
//         if (showHamburger) {
//             setOpen(false); // Closed by default on mobile/tablet
//         } else {
//             setOpen(true);  // Always open on desktop
//         }
//     }, [showHamburger]);

//     // Permission-based module filtering
//     useEffect(() => {
//         const employeeId = localStorage.getItem("employeeId");

//         // Get login data
//         const loginData = JSON.parse(localStorage.getItem("loginResponse") || "{}");
//         const modulesFromResponse = loginData?.modules || [];
//         const planTypes = loginData?.planTypes || [];
//         const businessVerticalsFromResponse = loginData?.businessVerticals || [];

//         let filteredModules = [];
//         let filteredBusinessVerticals = [];

//         if (employeeId && employeeId !== "0") {
//             // Employee → show only modules from login response
//             filteredModules = modulesFromResponse.map(m => m.trim().replace(/\s+/g, "_"));
//             filteredBusinessVerticals = businessVerticalsFromResponse;
//         } else {
//             // Parent vendor → show modules depending on plan type
//             if (planTypes.includes("BASIC")) {
//                 // BASIC has highest priority
//                 filteredModules = [
//                     "Company",
//                     "Home",
//                     "Settings_Controls",
//                     "Order_Management",
//                     "Menu_Management",
//                     "Account_History",
//                     "Report_Analysis",
//                     "Promotions_Discounts"
//                 ];
//                 filteredBusinessVerticals = ["FOOD_AND_BEVERAGES", "CATERINGS_SERVICES"];
//             } else if (planTypes.includes("PREMIUM")) {
//                 filteredModules = Object.keys(enumToMenuItemMap); // all modules
//                 filteredBusinessVerticals = businessVerticalsFromResponse;
//             } else if (planTypes.includes("STANDARD")) {
//                 filteredModules = modulesFromResponse.length > 0
//                     ? modulesFromResponse.map(m => m.trim().replace(/\s+/g, "_"))
//                     : ["Home", "Order_Management"];
//                 filteredBusinessVerticals = businessVerticalsFromResponse;
//             } else {
//                 filteredModules = ["Home", "Order_Management"];
//                 filteredBusinessVerticals = businessVerticalsFromResponse;
//             }
//         }

//         console.log("✅ Allowed modules:", filteredModules);
//         console.log("✅ Allowed businessVerticals:", filteredBusinessVerticals);

//         setAllowedModules(filteredModules);
//         setAllowedBusinessVerticals(filteredBusinessVerticals);
//     }, []);

//     // Filter menu items based on business verticals
//     useEffect(() => {
//         const loginData = JSON.parse(localStorage.getItem("loginResponse"));
//         const businessVerticals = loginData?.businessVerticals || [];

//         const filteredMenu = allMenuItems.filter(
//             (item) =>
//                 item.text === "Subscription" || businessVerticals.includes(item.vertical)
//         );

//         setMenuItems(filteredMenu);
//     }, []);

//     const handleMenuItemClick = (item) => {
//         // Toggle dropdown - only open/close dropdown, no navigation
//         if (selectedItem?.text === item.text) {
//             setDropdownOpen(!dropdownOpen);
//         } else {
//             setSelectedItem(item);
//             setDropdownOpen(true);
//         }
//     };

//     const handleDropdownItemClick = (route) => {
//         // This will handle navigation for dropdown items
//         navigate(route);
//         if (isMobile) setOpen(false);
//         setDropdownOpen(false); // Close dropdown after navigation
//     };

//     // Safe icon renderer function
//     const renderIcon = (IconComponent, size) => {
//         if (!IconComponent || typeof IconComponent === 'undefined') {
//             return <DashboardIcon fontSize={size} />; // Fallback icon
//         }
//         return <IconComponent fontSize={size} />;
//     };

//     // Filter dropdown content based on allowed modules
//     const getDropdownContent = (item) => {
//         let dropdownItems = [];

//         switch (item.text) {
//             case "Food & Beverages":
//                 dropdownItems = Object.values(enumToMenuItemMap);
//                 break;
//             case "Subscription":
//                 dropdownItems = Object.values(subscriptionEnumToMenuItemMap);
//                 break;
//             case "Catering & Services":
//                 dropdownItems = Object.values(cateringEnumToMenuItemMap);
//                 break;
//             case "Logistics & Supply":
//                 dropdownItems = [
//                     { text: "Shipping", icon: LocalShippingIcon, route: "/shipping" },
//                     { text: "Warehouse", icon: LocalShippingIcon, route: "/warehouse" },
//                 ];
//                 break;
//             case "Fresh & Grocery":
//                 dropdownItems = Object.values(groceryEnumMenuToMap);
//                 break;
//             default:
//                 dropdownItems = [];
//         }

//         // Filter dropdown items based on allowed modules
//         return dropdownItems.filter(dropdownItem => {
//             // Find the module key that matches this dropdown item
//             const moduleKey = Object.keys(enumToMenuItemMap).find(key =>
//                 enumToMenuItemMap[key].text === dropdownItem.text
//             );

//             // If we found a module key, check if it's allowed
//             // If no module key found (different vertical), allow it
//             return !moduleKey || allowedModules.includes(moduleKey);
//         });
//     };

//     return (
//         <>
//             {/* Open Panel Button - Only show when panel is closed */}
//             {!open && (
//                 <Box
//                     sx={{
//                         position: "fixed",
//                         top: isMobile ? "10%" : "18.5%",
//                         left: isMobile ? "10px" : "10px",
//                         zIndex: 1500,
//                     }}
//                 >
//                     <IconButton
//                         onClick={() => setOpen(true)}
//                         sx={{
//                             color: "#b15cd6",
//                             backgroundColor: "white",
//                             boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
//                             '&:hover': {
//                                 backgroundColor: "#f5f5f5",
//                             }
//                         }}
//                     >
//                         <ArrowForwardIosIcon fontSize="small" />
//                     </IconButton>
//                 </Box>
//             )}

//             <Drawer
//                 anchor="left"
//                 variant={showHamburger ? "temporary" : "persistent"}
//                 open={open}
//                 onClose={showHamburger ? () => setOpen(false) : undefined}
//                 PaperProps={{
//                     sx: {
//                         marginTop: isMobile ? "55px" : "64px",
//                         height: isMobile ? "calc(100vh - 60px)" : "calc(100vh - 60px)",
//                         width: drawerWidth,
//                         scrollbarWidth: "none",
//                         backgroundColor: "#fff",
//                         border: "3px solid white",
//                         // Hide scrollbar
//                         '&::-webkit-scrollbar': {
//                             display: 'none'
//                         },
//                         scrollbarWidth: 'none',
//                         '-ms-overflow-style': 'none'
//                     },
//                 }}
//                 ModalProps={{ keepMounted: true }}
//             >
//                 <Box sx={{
//                     width: "100%",
//                     height: "100%",
//                     overflowY: "auto",
//                     marginTop: isMobile ? "10px" : "60px",
//                     // Hide scrollbar
//                     '&::-webkit-scrollbar': {
//                         display: 'none'
//                     },
//                     // Hide scrollbar for Firefox
//                     scrollbarWidth: 'none',
//                     // Hide scrollbar for IE and Edge
//                     '-ms-overflow-style': 'none'
//                 }}>
//                     <List>
//                         {menuItems.length === 0 ? (
//                             <Box sx={{ color: "gray", padding: "1rem", textAlign: "center", fontSize: getTextSize() }}>
//                                 No menu items found
//                             </Box>
//                         ) : (
//                             menuItems.map((item, index) => {
//                                 const dropdownContent = getDropdownContent(item);
//                                 const isSelected = selectedItem?.text === item.text;

//                                 return (
//                                     <React.Fragment key={index}>
//                                         <ListItem disablePadding>
//                                             <ListItemButton
//                                                 sx={{
//                                                     background: isSelected && dropdownOpen ? "#A055B0" : "#B276C3",
//                                                     borderRadius: "20px",
//                                                     marginBottom: "10px",
//                                                     color: "#fff",
//                                                     "&:hover": { background: "#A055B0" },
//                                                     padding: "10px 16px",
//                                                     position: "relative", // For positioning the close button
//                                                 }}
//                                                 onClick={() => handleMenuItemClick(item)}
//                                             >
//                                                 {/* Close Panel Button - Only show when panel is open, placed on LEFT side */}
//                                                 {open && (
//                                                     <IconButton
//                                                         size="small"
//                                                         onClick={(e) => {
//                                                             e.stopPropagation(); // Prevent triggering the dropdown
//                                                             setOpen(false);
//                                                         }}
//                                                         sx={{
//                                                             color: "#fff",
//                                                             position: "absolute",
//                                                             left: "5px",
//                                                             top: "50%",
//                                                             transform: "translateY(-50%)",
//                                                             backgroundColor: "rgba(255,255,255,0.2)",
//                                                             '&:hover': {
//                                                                 backgroundColor: "rgba(255,255,255,0.3)",
//                                                             },
//                                                             marginRight: "5px",
//                                                         }}
//                                                     >
//                                                         <ArrowBackIosIcon fontSize="small" />
//                                                     </IconButton>
//                                                 )}

//                                                 {/* Main icon removed - only text remains */}
//                                                 <ListItemText
//                                                     primary={item.text}
//                                                     primaryTypographyProps={{
//                                                         style: {
//                                                             fontSize: getTextSize(),
//                                                             fontWeight: "bold",
//                                                             marginLeft: open ? "30px" : "0px" // Adjust text position when close button is visible
//                                                         },
//                                                     }}
//                                                 />

//                                                 {dropdownContent.length > 0 && (
//                                                     isSelected && dropdownOpen ? <ExpandLess /> : <ExpandMore />
//                                                 )}
//                                             </ListItemButton>
//                                         </ListItem>

//                                         {/* Dropdown Content */}
//                                         {dropdownContent.length > 0 && (
//                                             <Collapse in={isSelected && dropdownOpen} timeout="auto" unmountOnExit>
//                                                 <List component="div" disablePadding>
//                                                     {dropdownContent.map((dropdownItem, idx) => (
//                                                         <ListItemButton
//                                                             key={idx}
//                                                             sx={{
//                                                                 pl: 4,
//                                                                 background: location.pathname === dropdownItem.route ? "#A055B0" : "#B276C3",
//                                                                 borderRadius: "20px",
//                                                                 marginBottom: "10px",
//                                                                 color: "#fff",
//                                                                 "&:hover": { background: "#A055B0" },
//                                                                 padding: "10px 16px",
//                                                                 marginLeft: "8px",
//                                                                 marginRight: "8px",
//                                                             }}
//                                                             onClick={() => handleDropdownItemClick(dropdownItem.route)}
//                                                         >
//                                                             <Box sx={{
//                                                                 color: "#fff",
//                                                                 minWidth: "27px",
//                                                                 display: "flex",
//                                                                 alignItems: "center",
//                                                                 justifyContent: "center"
//                                                             }}>
//                                                                 {renderIcon(dropdownItem.icon, "small")}
//                                                             </Box>
//                                                             <ListItemText
//                                                                 primary={dropdownItem.text}
//                                                                 primaryTypographyProps={{
//                                                                     style: {
//                                                                         fontSize: getTextSize() === "11px" ? "10px" :
//                                                                             getTextSize() === "12px" ? "11px" : "12px",
//                                                                         fontWeight: "bold"
//                                                                     },
//                                                                 }}
//                                                             />
//                                                         </ListItemButton>
//                                                     ))}
//                                                 </List>
//                                             </Collapse>
//                                         )}
//                                     </React.Fragment>
//                                 );
//                             })
//                         )}
//                     </List>
//                 </Box>
//             </Drawer>
//         </>
//     );
// };

// export default LandingSideBar2;





import React, { useState, useEffect } from "react";
import {
    Box,
    IconButton,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    Drawer,
    useMediaQuery,
    useTheme,
    Collapse,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import {
    Home as HomeIcon,
    RestaurantMenu as RestaurantMenuIcon,
    Apartment as ApartmentIcon,
    Settings as SettingsIcon,
    Dashboard as DashboardIcon,
    DinnerDining as DinnerDiningIcon,
    Payment as PaymentIcon,
    Assessment as AssessmentIcon,
    Dashboard
} from "@mui/icons-material";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import {
    FaUtensils,
    FaConciergeBell,
    FaShoppingBasket,
    FaBuilding
} from "react-icons/fa";
import { Table } from "lucide-react";

// All possible menu items - these will only open dropdowns, not navigate
const allMenuItems = [
    // { text: "Subscription", icon: <HomeIcon />, vertical: "SUBSCRIPTION" },
    { text: "Food & Beverages", route: "/foodladingpage", vertical: "FOOD_AND_BEVERAGES" },
    // { text: "Catering & Services", icon: <RestaurantMenuIcon />, vertical: "CATERINGS_SERVICES" },
    // { text: "Logistics & Supply", icon: <LocalShippingIcon />, vertical: "LOGISTICS_SUPPLY" },
    // { text: "Fresh & Grocery", icon: <ShoppingBasketIcon />, vertical: "FRESH_GROCERIES" }
];

const subscriptionEnumToMenuItemMap = {
    Food_Beverages: {
        text: "Food & Beverages",
        icon: FaUtensils,
        route: "/mainladdingpage?vertical=food"
    },
    Catering_Services: {
        text: "Catering & Services",
        icon: FaConciergeBell,
        route: "/mainladdingpage?vertical=catering"
    },
    Fresh_Grocery: {
        text: "Fresh & Grocery",
        icon: FaShoppingBasket,
        route: "/mainladdingpage?vertical=grocery"
    },
    Logistics_Supply: {
        text: "Logistics & Supply",
        icon: LocalShippingIcon,
        route: "/mainladdingpage?vertical=logistics"
    },
    Banquet_Hall: {
        text: "Banquet Hall",
        icon: FaBuilding,
        route: "/mainladdingpage?vertical=banquet"
    },
};

// Your actual dropdown content mapping with safe icon handling
const enumToMenuItemMap = {
    Dashboard: {
        text: "Dashboard", icon: HomeIcon,
        route: "/fooddashboard"
    },
    // Home: { text: "Home", icon: HomeIcon, route: "/foodladingpage" },
    Company: { text: "Business Profile", icon: ApartmentIcon, route: "/foodbeveragescompany" },
    Team_Managment: {text: "Team", route: "/teammanagment"},
    Settings_Controls: {
        text: "Settings & Control",
        icon: SettingsIcon,
        route: "/foodsettings"
    },
    Menu_Management: {
        text: "Menu",
        icon: RestaurantMenuIcon,
        route: "/foodandbeveragesMenu"
    },
    Order_Management: {
        text: "Order",
        icon: DashboardIcon,
        route: "/foodordermanagment"
    },
    Chef_Management: {
        text: "Chef",
        icon: RestaurantMenuIcon,
        route: "/foodchefmanagment"
    },
    Delivery_Management: {
        text: "Delivery",
        icon: DinnerDiningIcon,
        route: "/foodwaitermanagment"
    },
    Account_History: {
        text: "Account & History",
        icon: PaymentIcon,
        route: "/foodAccuontdata"
    },
    Promotions_Discounts: {
        text: "Promotions",
        icon: PaymentIcon,
        route: "/foodandbeveragespromotions"
    },
    // Table_Management: {
    //     text: "Table",
    //     icon: AssessmentIcon,
    //     route: "/foodtablemanagment"
    // },
    // Inventory_Management: {
    //     text: "Inventory",
    //     icon: PaymentIcon,
    //     route: "/foodandbeveragesInvetory"
    // },
    Report_Analysis: {
        text: "Report & Analysis",
        icon: AssessmentIcon,
        route: "/foodandreporanalysis"
    },
    // Support_System: {
    //     text: "Support System",
    //     route: "/foodsupportsystem"
    // },
    Legal_Compliance: {
        text: "Leagl & Complaince",
        route: "/foodsupportsystem"
    }
};

const cateringEnumToMenuItemMap = {
    Home: { text: "Home", icon: HomeIcon, route: "/cateringlading" },
    Company: { text: "Profile", icon: ApartmentIcon, route: "/cateringsprofilepage" },
    Settings_Controls: {
        text: "Settings & Control",
        icon: SettingsIcon,
        route: "/cateringssettingpage"
    },
    Menu_Management: {
        text: "Menu",
        icon: RestaurantMenuIcon,
        route: "/cateringsmenuaddingpage"
    },
    Order_Management: {
        text: "Leads Orders",
        icon: DashboardIcon,
        route: "/cateringsorderspage"
    },
    Table_Management: {
        text: "Package Orders",
        icon: DashboardIcon,
        route: "/cateringpackageorders"
    },
    Account_History: {
        text: "Account & History",
        icon: PaymentIcon,
        route: "/caterigsaccount"
    },
    Promotions_Discounts: {
        text: "Promotions",
        icon: PaymentIcon,
        route: "/cateringspromotionspage"
    },
    Report_Analysis: {
        text: "Report & Analysis",
        icon: AssessmentIcon,
        route: "/cateringsreportanalysis"
    },
}

const groceryEnumMenuToMap = {
    Home: { text: "Home", icon: HomeIcon, route: "/groceryladingpage" },
    Company: { text: "Profile", icon: ApartmentIcon, route: "/groceryprofiledata" },
    Settings_Controls: {
        text: "Settings & Control",
        icon: SettingsIcon,
        route: "/grocerysettingsdata"
    },
    Menu_Management: {
        text: "Menu",
        icon: RestaurantMenuIcon,
        route: "/groceryandbeveragesMenu"
    },
    Order_Management: {
        text: "Order",
        icon: DashboardIcon,
        route: "/groceryorders"
    },
    Account_History: {
        text: "Account & History",
        icon: PaymentIcon,
        route: "/groceryaccuontdata"
    },
    Promotions_Discounts: {
        text: "Promotions",
        icon: PaymentIcon,
        route: "/groceryandbeveragespromotions"
    },
    Inventory_Management: { text: "Inventory", icon: PaymentIcon, route: "/groceryandbeveragesInvetory" },
    Report_Analysis: {
        text: "Report & Analysis",
        icon: AssessmentIcon,
        route: "/groceryandreporanalysis"
    },
}

const LandingSideBar2 = () => {
    const [open, setOpen] = useState(false);
    const [menuItems, setMenuItems] = useState([]);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [allowedModules, setAllowedModules] = useState([]);
    const [allowedBusinessVerticals, setAllowedBusinessVerticals] = useState([]);
    const [filteredMenuItems, setFilteredMenuItems] = useState([]); // NEW: For permission-based filtering
    const navigate = useNavigate();
    const location = useLocation();
    const theme = useTheme();

    // Media queries
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const isTablet = useMediaQuery(theme.breakpoints.between("sm", "lg"));
    const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));
    const isBelow500 = useMediaQuery("(max-width:500px)");
    const isBelow1315 = useMediaQuery("(max-width:1315px)");
    const isBetween1315And1399 = useMediaQuery("(min-width:1315px) and (max-width:1399px)");
    const isAbove1400 = useMediaQuery("(min-width:1450px)");

    // Your custom window width detection
    const isMobilee = window.innerWidth < 600;        // < 600px
    const isTablett = window.innerWidth >= 600 && window.innerWidth < 999; // 600px - 999px
    const isDesktopp = window.innerWidth >= 999;          // > 999px

    const showHamburger = isMobilee || isTablett; // true for mobile AND tablet

    let drawerWidth = 189; // default

    if (isBelow500) {
        drawerWidth = 200;
    } else if (isBelow1315) {
        drawerWidth = 176;
    } else if (isBetween1315And1399) {
        drawerWidth = 190;
    } else if (isAbove1400) {
        drawerWidth = 208;
    }

    const getIconSize = () => (isMobile ? "small" : "medium");
    const getTextSize = () => (isMobile ? "12px" : isTablet ? "0.8rem" : "1rem");

    // Set initial open state based on your custom window width detection
    useEffect(() => {
        if (showHamburger) {
            setOpen(false); // Closed by default on mobile/tablet
        } else {
            setOpen(true);  // Always open on desktop
        }
    }, [showHamburger]);

    // Permission-based module filtering - FROM REFERENCE FILE
    useEffect(() => {
        const employeeId = localStorage.getItem("employeeId");

        // Get login data
        const loginData = JSON.parse(localStorage.getItem("loginResponse") || "{}");
        const modulesFromResponse = loginData?.modules || [];
        const planTypes = loginData?.planTypes || [];
        const businessVerticalsFromResponse = loginData?.businessVerticals || [];

        let filteredModules = [];
        let filteredBusinessVerticals = [];

        if (employeeId && employeeId !== "0") {
            // Employee → show only modules from login response
            filteredModules = modulesFromResponse.map(m => m.trim().replace(/\s+/g, "_"));
            filteredBusinessVerticals = businessVerticalsFromResponse;
        } else {
            // Parent vendor → show modules depending on plan type
            if (planTypes.includes("BASIC")) {
                // BASIC has highest priority
                filteredModules = [
                    "Dashboard",
                    "Company",
                    "Home",
                    "Settings_Controls",
                    "Order_Management",
                    "Menu_Management",
                    "Account_History",
                    "Report_Analysis",
                    "Promotions_Discounts"
                ];
                filteredBusinessVerticals = ["FOOD_AND_BEVERAGES", "CATERINGS_SERVICES"];
            } else if (planTypes.includes("PREMIUM")) {
                filteredModules = Object.keys(enumToMenuItemMap); // all modules
                filteredBusinessVerticals = businessVerticalsFromResponse;
            } else if (planTypes.includes("STANDARD")) {
                filteredModules = modulesFromResponse.length > 0
                    ? modulesFromResponse.map(m => m.trim().replace(/\s+/g, "_"))
                    : ["Home", "Order_Management"];
                filteredBusinessVerticals = businessVerticalsFromResponse;
            } else {
                filteredModules = ["Home", "Order_Management"];
                filteredBusinessVerticals = businessVerticalsFromResponse;
            }
        }

        // console.log("✅ Allowed modules:", filteredModules);
        // console.log("✅ Allowed businessVerticals:", filteredBusinessVerticals);

        setAllowedModules(filteredModules);
        setAllowedBusinessVerticals(filteredBusinessVerticals);

        // NEW: Apply permission filtering to menu items - FROM REFERENCE FILE
        const permissionFilteredItems = Object.keys(enumToMenuItemMap)
            .filter((key) => filteredModules.includes(key))
            .map((key) => enumToMenuItemMap[key]);

        setFilteredMenuItems(permissionFilteredItems);
        //console.log("✅ Permission filtered menu items:", permissionFilteredItems);

    }, []);

    // Filter menu items based on business verticals
    useEffect(() => {
        const loginData = JSON.parse(localStorage.getItem("loginResponse"));
        const businessVerticals = loginData?.businessVerticals || [];

        const filteredMenu = allMenuItems.filter(
            (item) =>
                item.text === "Subscription" || businessVerticals.includes(item.vertical)
        );

        setMenuItems(filteredMenu);
    }, []);

    const handleMenuItemClick = (item) => {
        // Toggle dropdown - only open/close dropdown, no navigation
        if (selectedItem?.text === item.text) {
            setDropdownOpen(!dropdownOpen);
        } else {
            setSelectedItem(item);
            setDropdownOpen(true);
        }
    };

    const handleDropdownItemClick = (route) => {
        // This will handle navigation for dropdown items
        navigate(route);
        if (isMobile) setOpen(false);
        // setDropdownOpen(false); // Close dropdown after navigation
    };

    // Safe icon renderer function
    const renderIcon = (IconComponent, size) => {
        if (!IconComponent || typeof IconComponent === 'undefined') {
            return <DashboardIcon fontSize={size} />; // Fallback icon
        }
        return <IconComponent fontSize={size} />;
    };

    // Filter dropdown content based on allowed modules - UPDATED with permission filtering
    const getDropdownContent = (item) => {
        let dropdownItems = [];

        switch (item.text) {
            case "Food & Beverages":
                // NEW: Use permission-filtered items instead of all items
                dropdownItems = filteredMenuItems.length > 0 ? filteredMenuItems : Object.values(enumToMenuItemMap);
                break;
            case "Subscription":
                dropdownItems = Object.values(subscriptionEnumToMenuItemMap);
                break;
            case "Catering & Services":
                dropdownItems = Object.values(cateringEnumToMenuItemMap);
                break;
            case "Logistics & Supply":
                dropdownItems = [
                    { text: "Shipping", icon: LocalShippingIcon, route: "/shipping" },
                    { text: "Warehouse", icon: LocalShippingIcon, route: "/warehouse" },
                ];
                break;
            case "Fresh & Grocery":
                dropdownItems = Object.values(groceryEnumMenuToMap);
                break;
            default:
                dropdownItems = [];
        }

        // Additional filtering based on allowed modules for cross-vertical consistency
        return dropdownItems.filter(dropdownItem => {
            // Find the module key that matches this dropdown item
            const moduleKey = Object.keys(enumToMenuItemMap).find(key =>
                enumToMenuItemMap[key].text === dropdownItem.text
            );

            // If we found a module key, check if it's allowed
            // If no module key found (different vertical), allow it
            return !moduleKey || allowedModules.includes(moduleKey);
        });
    };

    return (
        <>
            {/* Open Panel Button - Only show when panel is closed */}
            {!open && (
                <Box
                    sx={{
                        position: "fixed",
                        top: isMobile ? "12%" : "150px",
                        left: isMobile ? "10px" : "10px",
                        zIndex: 1500,
                        display: window.innerWidth <= 900 ? "block" : "none",
                    }}
                >
                    <IconButton
                        onClick={() => setOpen(true)}
                        sx={{
                            color: "#b15cd6",
                            backgroundColor: "white",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                            '&:hover': {
                                backgroundColor: "#f5f5f5",
                            },
                            height:"25px",
                            width:"25px",
                        }}
                    >
                        <ArrowForwardIosIcon />
                    </IconButton>
                </Box>
            )}

            <Drawer
                anchor="left"
                variant={showHamburger ? "temporary" : "persistent"}
                open={open}
                onClose={showHamburger ? () => setOpen(false) : undefined}
                PaperProps={{
                    sx: {
                        marginTop: isMobile ? "52px" : "118px",
                        height: isMobile ? "calc(100vh - 50px)" : "calc(100vh - 50px)",
                        width: drawerWidth,
                        scrollbarWidth: "none",
                        backgroundColor: "#fff",
                        border: "3px solid white",
                        overflow: 'hidden', // Changed from auto to hidden
                        '&::-webkit-scrollbar': {
                            display: 'none'
                        },
                        scrollbarWidth: 'none',
                        '-ms-overflow-style': 'none',
                        zIndex: 1001,
                    },
                }}
                ModalProps={{ keepMounted: true }}
            >
                <Box sx={{
                    flexShrink: 0, // Prevents this from shrinking
                    background: '#fff',
                    zIndex: 10,
                    position: 'sticky',
                    top: 0,
                }}>
                    <List sx={{ paddingTop: "8px", marginBottom: "0px",paddingBottom:"0px" }}>
                        {menuItems.length === 0 ? (
                            <Box sx={{ color: "gray", padding: "1rem", textAlign: "center", fontSize: getTextSize() }}>
                                No menu items found
                            </Box>
                        ) : (
                            menuItems.map((item, index) => {
                                const dropdownContent = getDropdownContent(item);
                                const isSelected = selectedItem?.text === item.text;

                                return (
                                    <React.Fragment key={index} >
                                        <ListItem disablePadding sx={{ marginTop: "0px",marginBottom:"0px" }}>
                                            <ListItemButton
                                                sx={{
                                                    background: isSelected && dropdownOpen ? "#A055B0" : "#B276C3",
                                                    borderRadius: "20px",
                                                    marginBottom: "10px",
                                                    color: "#fff",
                                                    "&:hover": { background: "#A055B0" },
                                                    padding: "10px 16px",
                                                    position: "relative",
                                                }}
                                                onClick={() => handleMenuItemClick(item)}
                                            >
                                                {/* Close Panel Button */}
                                                {open && (
                                                    <IconButton
                                                        size="small"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            setOpen(false);
                                                        }}
                                                        sx={{
                                                            color: "#fff",
                                                            position: "absolute",
                                                            left: "5px",
                                                            top: "45%",
                                                            transform: "translateY(-50%)",
                                                            backgroundColor: "rgba(255,255,255,0)",
                                                            '&:hover': {
                                                                backgroundColor: "rgba(255,255,255,0)",
                                                            },
                                                            marginRight: "5px",
                                                            display: window.innerWidth <= 990 ? "block" : "none",
                                                        }}
                                                    >
                                                        <ArrowBackIosIcon fontSize="small" />
                                                    </IconButton>
                                                )}

                                                <ListItemText
                                                    primary={item.text}
                                                    primaryTypographyProps={{
                                                        style: {
                                                            fontSize: getTextSize(),
                                                            fontWeight: "bold",
                                                            marginLeft: window.innerWidth <= 990 ? "10px" : "0px",
                                                            

                                                        },
                                                    }}
                                                />

                                                {dropdownContent.length > 0 && (
                                                    isSelected && dropdownOpen ? <ExpandLess /> : <ExpandMore />
                                                )}
                                            </ListItemButton>
                                        </ListItem>
                                    </React.Fragment>
                                );
                            })
                        )}
                    </List>
                </Box>

                {/* Scrollable Area for Sub-buttons */}
                <Box sx={{
                    flex: 1, // Takes remaining space
                    overflowY: 'auto',
                    paddingBottom: '20px',
                    '&::-webkit-scrollbar': {
                        display: 'none'
                    },
                    scrollbarWidth: 'none',
                    '-ms-overflow-style': 'none'
                }}>
                    {menuItems.map((item, index) => {
                        const dropdownContent = getDropdownContent(item);
                        const isSelected = selectedItem?.text === item.text;

                        return (
                            dropdownContent.length > 0 && isSelected && dropdownOpen && (
                                <Box key={`dropdown-${index}`} sx={{ marginBottom: "10px" }}>
                                    <Collapse in={isSelected && dropdownOpen} timeout="auto" unmountOnExit>
                                        <List component="div" disablePadding sx={{marginBottom:"50px"}}>
                                            {dropdownContent.map((dropdownItem, idx) => (
                                                <ListItemButton
                                                    key={idx}
                                                    sx={{
                                                        pl: 4,
                                                        background: location.pathname === dropdownItem.route ? "#A055B0" : "#B276C3",
                                                        borderRadius: "20px",
                                                        marginBottom: "10px",
                                                        color: "#fff",
                                                        "&:hover": { background: "#A055B0" },
                                                        padding: "10px 16px",
                                                        marginLeft: "8px",
                                                        marginRight: "8px",
                                                    }}
                                                    onClick={() => handleDropdownItemClick(dropdownItem.route)}
                                                >
                                                    <Box sx={{
                                                        color: "#fff",
                                                        minWidth: "27px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center"
                                                    }}>
                                                        {renderIcon(dropdownItem.icon, "small")}
                                                    </Box>
                                                    <ListItemText
                                                        primary={dropdownItem.text}
                                                        primaryTypographyProps={{
                                                            style: {
                                                                fontSize: getTextSize() === "11px" ? "10px" :
                                                                    getTextSize() === "12px" ? "11px" : "12px",
                                                                fontWeight: "bold",
                                                            },
                                                        }}
                                                    />
                                                </ListItemButton>
                                            ))}
                                        </List>
                                    </Collapse>
                                </Box>
                            )
                        );
                    })}
                </Box>
            </Drawer>
        </>
    );
};

export default LandingSideBar2;